import styled from "styled-components";

export const OurTeamContainer = styled.div``;

export const InfoContainer = styled.div`
  color: #fff;
  background: #fff @media screen and (max-width: 768px) {
    padding: 100px 0;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  z-index: 1;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding: 4rem 0rem;
  justify-content: center;
`;

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 3rem calc((100vw - 1300px) / 2);
  align-items: start;
  grid-template-areas: "col1 col2";

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-areas: "col1 col1" "col2 col2";
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;

export const TopLine = styled.p`
  color: #339933;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;
  color: ${({ lightText }) => (lightText ? "#f7f8fa" : "#010606")};

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const SubHeading = styled.p`
  color: #339933;
  font-size: 13px;
  line-height: 12px;
  font-weight: 400px;
  letter-spacing: 1px;
  margin-bottom: 16px;
`;

export const SubTitle = styled.p`
  margin-width: 440px;
  margin-bottom: 35px;
  font-size: 13px;
  line-height: 24px;
  color: #010606;
  white-space: pre-line;
`;

export const ImgWrap = styled.div`
  margin-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  margin: 0 0 10px 0;
  padding-right: 0;

  border-radius: ${({ profilePic }) => (profilePic ? "125px" : "0")};
  border: 5px solid #339933;
`;
